import { useContext, useEffect } from 'react';
import { DashboardContext } from '@/layouts/DashboardLayout';
import teamsContext from '@providers/Teams/TeamsContext';
import { useCreatorUI } from '../CreatorUI';
import { RxDBContext } from './RxDBProvider';

const RxDBCreatorIdWatcher: React.FC = () => {
  const { setCreatorId } = useContext(RxDBContext);

  const { isInDashboard } = useContext(DashboardContext);
  const { creatorId: creatorIdFromTeamsContext } = useContext(teamsContext);
  const creatorUI = useCreatorUI();
  const creatorId = (isInDashboard && creatorIdFromTeamsContext) || creatorUI?.id;

  useEffect(() => {
    setCreatorId(creatorId);
  }, [creatorId, setCreatorId]);
  return null;
};

export default RxDBCreatorIdWatcher;